import { Step, StepIcon, StepIndicator, Stepper, StepSeparator, StepStatus } from '@chakra-ui/react'

import type { FormWizardV2Step } from './types'

export default function FormWizardV2ChecklistHorizontalStepper<T extends string>({
  steps,
  currentStep,
}: {
  steps: FormWizardV2Step<T>[]
  currentStep: FormWizardV2Step<T>
}): JSX.Element {
  const visibleSteps = steps.filter(item => item.disabled !== 'hidden')
  const activeStepIndex = visibleSteps.findIndex(step => step.slug === currentStep.slug)

  return (
    <Stepper size="sm" index={activeStepIndex} overflowX="hidden" gap={0}>
      {visibleSteps.map(step => (
        <Step key={step.title} style={{ gap: 0 }}>
          <StepIndicator bg="bg" borderWidth="1px" borderStyle="solid">
            <StepStatus complete={<StepIcon />} />
          </StepIndicator>
          <StepSeparator style={{ marginLeft: 0 }} />
        </Step>
      ))}
    </Stepper>
  )
}
